import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import ProtectedRoute from "@/components/ProtectedRoute";
import GrainOverlay from "@/components/GrainOverlay";

function App() {
  // Title is now managed dynamically by <SEOHead /> from CMS-published content.
  // We set a sensible initial fallback in case SEOHead hasn't mounted yet.
  useEffect(() => {
    if (!document.title) {
      document.title = "Ranjana Baruah — Engineer · Artist · Designer · Founder";
    }
  }, []);

  return (
    <div className="App relative">
      <GrainOverlay />
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
